import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuthStore } from '../../store/auth.store';
import { Observable } from 'rxjs';

export const mainLayoutResolver: ResolveFn<boolean | Observable<any>> = (route, state) => {
  const authStore = inject(AuthStore)
  return authStore.getUserInfoResolve();
};
